import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { TimezoneSelectComponent } from './timezone-select.component';

export interface FormlyTimezoneSelectFieldConfig extends FormlyFieldConfig<FormlyFieldProps> {
  type: 'timezone-select' | Type<FormlyTimezoneSelectComponent>;
}

@Component({
  imports: [ReactiveFormsModule, TimezoneSelectComponent, FormlyModule],
  selector: 'vectronic-formly-timezone-select-wrapper',
  template: `<vectronic-formly-timezone-select
    [formControl]="formControl"
    [id]="id"
    [name]="field.name"
    [formlyAttributes]="field"
    [tabIndex]="props?.tabindex"
    [label]="props?.label"
    [required]="props?.required"
    [readonly]="props?.readonly"
    [placeholder]="props?.placeholder"
    [invalid]="showError && formControl.hasError('required')"
  >
    <formly-validation-message [field]="field"></formly-validation-message>
  </vectronic-formly-timezone-select>`,
})
export class FormlyTimezoneSelectComponent extends FieldType<FieldTypeConfig<FormlyFieldProps>> {}
